import useUserStore from 'store/useUserStore';
import { PropertyStatisticsActionEnum } from 'types/PropertyStatistics';
import { usePublicSavePropertyStatistics } from 'hooks/usePublicSavePropertyStatistics';
import usePropertiesStore from 'store/usePropertiesStore';

export const usePropertyStatistics = () => {
    const { userInfo } = useUserStore();
    const { savePropertyStatistics } = usePropertiesStore();
    const { mutate: savePublicPropertyStatistics } = usePublicSavePropertyStatistics();

    const isLoggedIn = !!userInfo;

    const saveStatistics = async (data: { webPageId: string; action: PropertyStatisticsActionEnum }): Promise<number> => {
        if (isLoggedIn) {
            // Use the authenticated endpoint for logged-in users
            return await savePropertyStatistics(data);
        } else {
            // Use the public endpoint for non-logged-in users
            return new Promise((resolve) => {
                savePublicPropertyStatistics(data, {
                    onSuccess: (status) => resolve(status),
                    onError: () => resolve(500), // Return 500 on error
                });
            });
        }
    };

    return {
        saveStatistics,
        isLoggedIn,
    };
};
